import * as angular from 'angular';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';

class AnalyticsController extends ViewportController {
    public static $inject = ['$scope', '$translate'];
    constructor(
        private $scope: ng.IScope,
        private $translate: angular.translate.ITranslateService
    ) {
        super($scope);
    }
}

angular
    .module('naut')
    .component('analytics', {
        template: require('./analytics.component.html'),
        controller: AnalyticsController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/components/analytics/analytics.component.ts